class Sponsor {
  title: string;
  url: string;
  image: string;
  image_thumb: string

  constructor(data: any) {
    this.title = data.title;
    this.url = data.url;
    this.image = data.image;
    this.image_thumb = data.image_thumb;
  }
}

export { Sponsor };
